<div class="skeleton-loader">
    <ng-container *ngIf="reportType === reportsChartEnum.tableView">
        <div class="table-section">
            <div *ngFor="let a of loaderList" class="row loader-body"></div>
        </div>
    </ng-container>

    <ng-container *ngIf="reportType === reportsChartEnum.pieChart">
        <div class="circle-section">
            <div class="circle loader-body" [ngStyle]="{'height': height, 'width': width}"></div>
        </div>
    </ng-container>

    <ng-container *ngIf="reportType === reportsChartEnum.barChart">
        <div class="bar-section">
            <div class="bar loader-body"></div>
            <div class="bar loader-body"></div>
            <div class="bar loader-body"></div>
            <div class="bar loader-body"></div>
            <div class="bar loader-body"></div>
            <div class="bar loader-body"></div>
        </div>
    </ng-container>

    <ng-container *ngIf="reportType === reportsChartEnum.overView">
        <div class="overview-loader" [class.overview-loader-grid]="gridColumn > 0"
            [ngStyle]="{'grid-template-columns': gridColumn > 0 ? 'repeat('+gridColumn+', auto)' : ''}">

            <div *ngFor="let a of loaderList" class="overview loader-body" [ngStyle]="{'height': height, 'width': width}"></div>
        </div>
    </ng-container>

    <ng-container *ngIf="reportType === reportsChartEnum.horizontalBarChart">
        <div class="hortizontalBar-loader">
            <div class="hbarChart loader-body"></div>
            <div class="hbarChart loader-body"></div>
            <div class="hbarChart loader-body"></div>
        </div>
    </ng-container>

    <ng-container *ngIf="reportType === reportsChartEnum.searchloader">
        <div class="searching-loader">
            <div class="circle-section">
                <div class="circle loader-body" [ngStyle]="{'height': height, 'width': width}"></div>
            </div>
            <div class="searching-loader-row">
                <div class="loader-body l1" style="width: 100px; height: 6px; border-radius: 99px;"></div>
                <div class="loader-body l2" style="width: 50px; height: 6px;  border-radius: 99px;"></div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="reportType === reportsChartEnum.lineChart">
        <div class="line-chart-loader">
            <div class="line-chart">
                <div class="hortizontalBar-loader">
                    <div class="hbarChart loader-body" [ngStyle]="{'height': height, 'width': width }"></div>
                    <div class="hbarChart loader-body" [ngStyle]="{'height': height, 'width': width }"></div>
                </div>
                <div class="y-axis">
                    <div class="hbarChart loader-body" style="width: 50px; height: 8px; border-radius: 5px;"></div>
                    <div class="hbarChart loader-body" style="width: 50px; height: 8px; border-radius: 5px;"></div>
                    <div class="hbarChart loader-body" style="width: 50px; height: 8px; border-radius: 5px;"></div>
                    <div class="hbarChart loader-body" style="width: 50px; height: 8px; border-radius: 5px;"></div>
                    <div class="hbarChart loader-body" style="width: 50px; height: 8px; border-radius: 5px;"></div>
                </div>
                <div class="x-axis">
                    <div class="hbarChart loader-body" style="width: 60px; height: 8px; border-radius: 5px;"></div>
                    <div class="hbarChart loader-body" style="width: 60px; height: 8px; border-radius: 5px;"></div>
                    <div class="hbarChart loader-body" style="width: 60px; height: 8px; border-radius: 5px;"></div>
                    <div class="hbarChart loader-body" style="width: 60px; height: 8px; border-radius: 5px;"></div>
                    <div class="hbarChart loader-body" style="width: 60px; height: 8px; border-radius: 5px;"></div>
                    <div class="hbarChart loader-body" style="width: 60px; height: 8px; border-radius: 5px;"></div>
                </div>
            </div>
        </div>
    </ng-container>
</div>